import { render } from "./ParticipantDetailsV2.vue?vue&type=template&id=2d7975f4&scoped=true"
import script from "./ParticipantDetailsV2.vue?vue&type=script&lang=js"
export * from "./ParticipantDetailsV2.vue?vue&type=script&lang=js"

import "./ParticipantDetailsV2.vue?vue&type=style&index=0&id=2d7975f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d7975f4"]])

export default __exports__